import React from 'react';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';

type Props = { link: string; event_name: string; className: string };

const AiToolkitLink = ({ link, event_name, className }: Props) => {
  const { sendEvent } = useClickStreamEvent();

  const handleClick = () => {
    sendEvent({
      eventType: 'click',
      eventInfo: event_name,
    });
  };
  return (
    <a href={link} className={className} onClick={handleClick}>
      Ответы в кармане
    </a>
  );
};

export default AiToolkitLink;
